import { convertMarkdownToHtml, displayDate, escapeHtml } from "~/plugins/functions/display";
import _ from 'lodash';

export interface IModelConversationDetailMessageResponse {
  aiMessage: string | null;
  conversationId: string;
  createdAt: string | Date;
  humanMessage: string;
  isMaxToken: boolean;
  id: string;
  status: string;
  updatedAt: string | Date;
  files: IModelPOSTConversationAssociationConversationFileRespone[];
  parentId: string | null;
  versionPosition: number;
  versionTotal: number;
  thumbs: string | null;
  thumbsDownComment: string | null;
  sources: IModelConversationSource[];

  processHeader: string;
  isAborted: boolean;
  genImage: any;
  generatedImages: IModelPOSTConversationAssociationConversationFileRespone[];
}

export class ModelConversationDetailProcess {
  title: string;
  description: string;
  createdAt: string | Date;
  constructor(props = {} as any) {
    this.title = '';
    this.description = '';
    this.createdAt = '';
  }
}

export class ModelConversationDetailMessage {
  aiMessage: string | null;
  conversationId: string;
  createdAt: string | Date;
  humanMessage: string;
  isMaxToken: boolean;
  id: string;
  status: string;
  updatedAt: string | Date;
  isNewAIMessage: boolean;
  filesList: ModelPOSTConversationAssociationConversationFile[];
  parentId: string | null;
  versionPosition: number;
  versionTotal: number;

  displayCreatedAt: string;
  displayUpdatedAt: string;
  aiMessageList: string[];
  processHeader: string;
  processPreviousTitle: string;
  processList: ModelConversationDetailProcess[];
  isEndStream: boolean;

  thumbs: string | null;
  thumbsDownComment: string | null;

  sourceList: ModelSource[];
  isAborted: boolean;

  isGenerateImage: boolean;
  generatedImagesList: ModelPOSTConversationAssociationConversationFile[];


  constructor(props = {} as IModelConversationDetailMessageResponse) {
    this.aiMessage = convertMarkdownToHtml(props.aiMessage || '', { isEndStream: true });
    this.conversationId = props.conversationId;
    this.createdAt = props.createdAt;
    this.humanMessage = props.humanMessage;
    this.isMaxToken = props.isMaxToken || false;
    this.id = props.id;
    this.status = props.status;
    this.updatedAt = props.updatedAt;
    this.filesList = (props.files || []).map(e => new ModelPOSTConversationAssociationConversationFile(e));
    this.parentId = props.parentId;
    this.versionPosition = props.versionPosition || 1;
    this.versionTotal = props.versionTotal || 1;

    this.displayCreatedAt = displayDate(this.createdAt, {
      isTimeOnly: true
    });
    this.displayUpdatedAt = displayDate(this.updatedAt, {
      isTimeOnly: true
    });
    this.isNewAIMessage = false;
    this.aiMessageList = [];
    this.processHeader = props.processHeader || ' ';
    // this.processHeader = `${(this.humanMessage || '').trim()}`;
    this.processPreviousTitle = '';
    this.processList = [];
    this.isEndStream = false  || this.status === 'completed';
    this.thumbs = props.thumbs || null;
    this.thumbsDownComment = props.thumbsDownComment || null;
    this.sourceList = (props.sources || []).map(e => new ModelSource(e));
    this.isAborted = props.isAborted || false;
    this.isGenerateImage = false;
    this.generatedImagesList = (props.genImage || []).map((e:any) => new ModelPOSTConversationAssociationConversationFile(e));
  }
}

export interface IModelConversationDetailResponse {
  id: string;
  presetId: string;
  presetActiveId: string;
  conversationMessages: IModelConversationDetailMessageResponse[];
  preset: {
    name: string;
    softDeleted: boolean;
  }

  workflowActiveId: string;
  model: string;
  // model: {
  //   name: string;
  // };
  modelActiveName: string;
}

export class ModelConversationDetail {
  id: string;
  presetId: string;
  presetActiveId: string;
  conversationMessageList: ModelConversationDetailMessage[];

  workflowActiveId: string;
  isWorkflow: boolean;
  natSubscribeValue: any;
  preset: {
    name: string;
    softDeleted: boolean;
  };
  isDeleted: boolean;
  isPresetSelected: boolean;
  totalConversationMessageList: ModelConversationDetailMessage[];

  // model: {
  //   name: string;
  // }
  model: string
  modelActiveName: string;

  constructor(props = {} as IModelConversationDetailResponse) {
    this.id = props.id;
    this.presetId = props.presetId || useRuntimeConfig().public.defaultPresetId;
    this.presetActiveId = props.presetActiveId || useRuntimeConfig().public.defaultPresetActiveId;
    this.conversationMessageList = (props.conversationMessages || []).map(e => new ModelConversationDetailMessage(e));
    this.preset = props.preset ?? {};

    this.workflowActiveId = props.workflowActiveId;
    this.isWorkflow = !!this.workflowActiveId;

    if (this.isWorkflow) {
      this.presetActiveId = `workflow_${this.workflowActiveId}`;
    }

    this.natSubscribeValue = null;
    this.isDeleted = this.preset.softDeleted;
    // this.isPresetSelected = true;
    this.isPresetSelected = (!!this.presetId || this.isWorkflow) && !this.isDeleted;

    this.totalConversationMessageList = _.cloneDeep(this.conversationMessageList);
    // this.model = props.model || { name: '' };
    this.model = props.model ||  '' ;
    this.modelActiveName = props.model || props.modelActiveName || 'gemini';
  }
}

export interface IModelPOSTConversationAssociationConversationFileRespone {
  fileName: string;
  filePath: string;
  fileSize: string;
  mimeType: string;
}

export interface IModelConversationSource {
  url: string;
  type: string;
  title: string;
}

export class ModelSource {
  url: string;
  type: string;
  title: string;

  constructor(props = {} as IModelConversationSource) {
    this.url = props.url || '';
    this.type = props.type || '';
    this.title = props.title || '';
  }
}

export class ModelPOSTConversationAssociationConversationFile {
  fileName: string;
  filePath: string;
  fileSize: string;
  mimeType: string;

  displayFile: string;

  constructor(props = {} as IModelPOSTConversationAssociationConversationFileRespone) {
    this.fileName = props.fileName || '';
    this.filePath = props.filePath || '';
    this.fileSize = props.fileSize || '';
    this.mimeType = props.mimeType || '';

    this.displayFile = ''
  }
}